<div class="issue-widget-follow-up-aggregate" *ngIf="!isClosedLoading && !isPendingLoading">
	<div class="issue-title">
		<span translate>issue.widget.overviewofqi</span>
	</div>

	<a
		class="issue-widget-follow-up-aggregate-step first-aggregate-step"
		mat-ripple
		*ngIf="{ disabled: !pendingCount || pendingCount === 0 || !user.isClaimReader() && !user.isClaimValidator() } as pending"
		[matRippleDisabled]="pending.disabled"
		[class.copo-clickable]="!pending.disabled"
		[routerLink]="['/quality-issues', 'list']"
		[state]="getQualityIssueListState('pending')">
		<div class="issue-widget-follow-up-aggregate-icon issue-widget-follow-up-aggregate-icon-border">
			<mat-icon class="issue-widget-follow-up-list-card-pending-icon" svgIcon="pending"></mat-icon>
		</div>
		<div class="issue-widget-follow-up-aggregate-label label-orange-color">
			<span translate>issue.pending</span>
		</div>
		<div class="issue-widget-follow-up-aggregate-value">
			<span>{{ pendingCount }}</span>
		</div>
	</a>
	<a
		class="issue-widget-follow-up-aggregate-step"
		mat-ripple
		*ngIf="{ disabled: !closedCount || closedCount === 0 || !user.isClaimReader() && !user.isClaimValidator() } as closed"
		[matRippleDisabled]="closed.disabled"
		[class.copo-clickable]="!closed.disabled"
		[routerLink]="['/quality-issues', 'list']"
		[state]="getQualityIssueListState('closed')">
		<div class="issue-widget-follow-up-aggregate-icon issue-widget-follow-up-aggregate-icon-border">
			<mat-icon class="issue-widget-follow-up-list-card-closed-icon" svgIcon="closed"></mat-icon>
		</div>
		<div class="issue-widget-follow-up-aggregate-label label-orange-color">
			<span translate>global.closed</span>
		</div>
		<div class="issue-widget-follow-up-aggregate-value">
			<span>{{ closedCount }}</span>
		</div>
	</a>
</div>
<button
	type="button" mat-button
	class="widget-button widget-button-accent"
	[routerLink]="['/quality-issues/new/batch-selection']"
	*ngIf="!isClosedLoading && !isPendingLoading && user.hasService('QUAPP') && (user.isClaimDetector() || user.isClaimValidator())"
>
	<span translate>claim.raise-new-quality-issue</span>
</button>
<copo-loading-spinner *ngIf="isClosedLoading || isPendingLoading"></copo-loading-spinner>